import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { AiService } from '../../ai/services/ai.service';
import { UserService } from '../../services/user.service';
import { SearchService } from '../../search/services/search.service';

/**
 * Component to perform AI-based extraction of document content.
 */
@Component({
  selector: 'ai-extraction',
  templateUrl: './ai-extraction.component.html',
  styleUrl: './ai-extraction.component.css'
})
export class AiExtractionComponent implements OnInit {
	@Input() product: any;
	
	LOCALIZATION: any;
	Object = Object;
	
	userinput: string = "";
	provider: string = "open_ai";
	providers: { [key: string]: { available: boolean; name: string; models: any[]; model?: string } } = {
	    "local_llm": {
	        available: true,
	        name: '',
	        models: []
	    },
		"open_ai": {
			available: true,
			name: '',
			models: [],
			model: 'gpt-4o-mini'
		}		
	};
	
	result = {
		extractions: [] as any,
		source_documents: [] as { source: string; filename?: string; content?: string }[], 
		answer: '',
		model: '',
		createdStr: '',
		totalTokenUsage: 0
	};
	submitting: boolean = false;
	
	constructor(
		private ngbmodalService: NgbActiveModal,
		private aiService: AiService,
		private userService: UserService,
		private alertsService: AlertsService,
		private searchService: SearchService
	) { }
	
	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.initProviders();
	}
	
	private initProviders(): void {
		this.providers["local_llm"].name = this.aiService.registry["local_llm"].name;
		this.providers["open_ai"].name = this.aiService.registry["open_ai"].name;
		
	    let types = Object.keys(this.providers);
	    for (let i = 0; i < types.length; i++) {
	        (type => {
	            this.aiService.ping(type).then(
	                (response: any) => {
	                    this.providers[type].available = true;
	                },
	                () => {
	                    this.providers[type].available = false;
	                }
	            );
	            
	            this.aiService.getModels(type).then(
	                (response: any) => {
	                    this.providers[type].models = response;
	                },
	                () => {
	                    this.providers[type].models = [];
	                }
	            );
	        })(types[i]);
	    }
	}
	
	/**
	 * Submits the request to the selected AI provider.
	 */
    submitRequest(): void {
		this.submitting = true;
        this.result.extractions = [];
		
		console.log("provider = %s", this.provider);
		
		if (this.provider === "local_llm") {
			let ismock = false;
			this.aiService.promptLLM([this.product.id], this.userinput, ismock).then(
				(response: any) => {
					this.submitting = false;
	
					this.result = response;
					this.result.source_documents.forEach(d => {
					    d.filename = d.source.split('/').pop();
					});
	                this.result.model = this.providers[this.provider].name;
	
					let d = new Date(response.created);
					let createdStr = d.toLocaleDateString('en-US');
					this.result.createdStr = createdStr;
				}, 
				() => {
	                this.submitting = false;
	                this.alertsService.error({
	                    message: "Failed to submit the prompt request."
	                });
				}
			);	
            				
		} else if (this.provider === "open_ai") {
			this.aiService.extract('basic', [this.product.id], this.userinput, false, this.providers[this.provider].model).then(
				(response: any) => {
					this.submitting = false;
					
					// Just pick the first extraction for now
					let result = response[0];
					let extractions = result.extractions;
	            	for (let i = 0; i < extractions.length; i++) {
	                	 this.result.extractions.push({ "key": extractions[i].key, "value": extractions[i].values });
	            	}
	            	this.result.model = result.model;
	            	this.result.totalTokenUsage = result.totalTokenUsage;
					
					let d = new Date(result.created * 1000 );
					let createdStr = d.toLocaleDateString('en-US');
					this.result.createdStr = createdStr;
				}, 
				() => {
	                this.submitting = false;
	                this.alertsService.error({
	                    message: "Failed to submit the extraction request."
	                });
				}
			);				
		} else {
			console.error("Provider is not supported");
		}
    }
	    
	/**
	 * Executes a search for the document with the given filename.
	 */	
    searchDoc(source: string): void {
		let filename = source.split('/').pop();
    	let solrQuery = 'document_path:' + filename; 
    	let solrQueryType = "2";
    	let options = {
    		query: solrQuery,
    		queryType: solrQueryType,
    		sortField: "Rank",
    		sortDirection: "DESC"
    	};
    	let criteria = [] as any[];
		
		console.log("Searching using options:");
		console.log(options);

		this.searchService.broadcastUserTriggeredCriteriaUpdateEvent(criteria, options);
    	
		// TODO: Close the doc viewer if it is open
		  
		this.close();      
	}	

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}	
}
